import React from "react";
import { api_auth, api_host } from "../../../../common/globals/constants";

export function useFlashboardConfigData() {
    const [isLoading, setIsLoading] = React.useState(true);
    const [data, setData] = React.useState({
        objetivos: [],
        info: { titulo: "", logo: "" },
    });
    const [isError, setIsError] = React.useState(false);
    const [error, setError] = React.useState("");
    const dateMilisegundos = Date.now();

    React.useEffect(() => {
        fetchData();
    }, []);

    async function fetchData() {
        setIsLoading(true);
        setIsError(false);
        try {
            const token = sessionStorage.getItem("key");
            const user = sessionStorage.getItem("user");
            const response = await fetch(
                `${api_host}/reporte/online/indicadores/getFlashboardList/?token=${token}&user=${user}&key=${api_auth}&date=${dateMilisegundos}`
            );
            
            if (!response.ok) {
                throw new Error("Error al cargar los datos desde el servidor");
            }
            const data = await response.json();
            setData(data);
        } catch (err) {
            console.error(err);
            setIsError(true);
            setError(err.message || "Ha ocurrido un error");
        } finally {
            setIsLoading(false);
        }
    }

    function refetch() {
        fetchData();
    }

    return { isLoading, data, isError, refetch, error };
}
